import { NgModule } from '@angular/core';
import { AppLoaderComponent } from './app-loader.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        AppLoaderComponent,
    ],
    imports: [
      CommonModule,
      ReactiveFormsModule
    ],
    exports: [
        AppLoaderComponent
    ],
    providers: [
    ]
})
export class AppLoaderModule {}